<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 mb-5 w-100">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <h1 class="modal-title m-auto">{{ "ACCOUNT_SETTING" | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mb-5">
    <p class="text-center heading-one">{{ "NEW_NAME" | translate }}</p>
    <p class="paragraph-text text-center">
      {{ "PLEASE_ENTER_NEW_NAME" | translate }}
    </p>
  </div>

  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <form [formGroup]="changeNameForm">
      <div class="rounded-top form-field">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ "USER_FIRST_NAME" | translate }}</mat-label>
          <input matInput formControlName="firstName" />
          <mat-error>
            <span *ngIf="formInstance?.firstName?.errors?.required">{{
              "YOU_MUST_ENTER_FIRST_NAME" | translate
            }}</span>
          </mat-error>

          <mat-error [ngSwitch]="true">
            <span
              class="no-wrap-error"
              *ngIf="
                formInstance?.firstName?.errors?.firstCharacterIsNumber &&
                !formInstance?.firstName?.errors?.whitespace &&
                !formInstance?.firstName?.errors?.required &&
                !formInstance?.firstName?.errors?.nameWithAllowedSpecialChars
              "
            >
              {{
                "FIRST_LETTER_MUST_BE_ALPHABETIC_CHARACTERS_ONLY" | translate
              }}
            </span>
          </mat-error>
          <mat-error>
            <span
              *ngIf="
                formInstance?.firstName?.errors?.nameWithAllowedSpecialChars &&
                !formInstance?.firstName?.errors?.whitespace
              "
            >
              {{ "PLEASE_ENTER_A_VALID_NAME" | translate }}
            </span>
          </mat-error>

          <mat-error *ngIf="formInstance?.firstName?.errors?.whitespace"
            >{{ "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate }}
          </mat-error>
          <mat-error *ngIf="formInstance?.firstName?.errors">
            <ng-container [ngSwitch]="true">
              <ng-container
                *ngSwitchCase="formInstance.firstName.errors.maxlength"
              >
                {{
                  commonService.stringInterPolation(
                    "MAXIMUM_OF_CHARACTERS" | translate,
                    "32"
                  )
                }}
              </ng-container>
              <ng-container
                *ngSwitchCase="
                  !formInstance.firstName.errors.required &&
                  !formInstance.firstName.errors.whitespace &&
                  !formInstance.firstName?.errors
                    ?.nameWithAllowedSpecialChars &&
                  !formInstance?.firstName?.errors?.firstCharacterIsNumber
                "
              >
                {{
                  commonService.stringInterPolation(
                    "MAXIMUM_OF_CHARACTERS" | translate,
                    "32"
                  )
                }}
              </ng-container>
              <ng-container *ngSwitchDefault> </ng-container>
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="rounded-top form-field pt-1">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ "USER_LAST_NAME" | translate }}</mat-label>
          <input matInput formControlName="lastName" />
          <mat-error>
            <span *ngIf="formInstance?.lastName?.errors?.required">{{
              "YOU_MUST_ENTER_LAST_NAME" | translate
            }}</span>
          </mat-error>

          <mat-error [ngSwitch]="true">
            <span
              class="no-wrap-error"
              *ngIf="
                formInstance?.lastName?.errors?.firstCharacterIsNumber &&
                !formInstance?.lastName?.errors?.whitespace &&
                !formInstance?.lastName?.errors?.required &&
                !formInstance?.lastName?.errors?.nameWithAllowedSpecialChars
              "
            >
              {{
                "FIRST_LETTER_MUST_BE_ALPHABETIC_CHARACTERS_ONLY" | translate
              }}
            </span>
          </mat-error>
          <mat-error>
            <span
              *ngIf="
                formInstance?.lastName?.errors?.nameWithAllowedSpecialChars &&
                !formInstance?.lastName?.errors?.whitespace
              "
            >
              {{ "PLEASE_ENTER_A_VALID_NAME" | translate }}
            </span>
          </mat-error>

          <mat-error *ngIf="formInstance?.lastName?.errors?.whitespace"
            >{{ "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate }}
          </mat-error>
          <mat-error *ngIf="formInstance?.lastName?.errors">
            <ng-container [ngSwitch]="true">
              <ng-container
                *ngSwitchCase="formInstance.lastName.errors.maxlength"
              >
                {{
                  commonService.stringInterPolation(
                    "MAXIMUM_OF_CHARACTERS" | translate,
                    "32"
                  )
                }}
              </ng-container>
              <ng-container
                *ngSwitchCase="
                  !formInstance.lastName.errors.required &&
                  !formInstance.lastName.errors.whitespace &&
                  !formInstance.lastName?.errors?.nameWithAllowedSpecialChars &&
                  !formInstance?.lastName?.errors?.firstCharacterIsNumber
                "
              >
                {{
                  commonService.stringInterPolation(
                    "MAXIMUM_OF_CHARACTERS" | translate,
                    "32"
                  )
                }}
              </ng-container>
              <ng-container *ngSwitchDefault> </ng-container>
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div class="row w-100 px-3">
    <div class="w-100">
      <button
        class="btn btn-danger update-btn px-3"
        [disabled]="!changeNameForm.valid"
        (click)="updateName()"
      >
        {{ "UPDATE" | translate }}
      </button>
    </div>
  </div>
</div>
